import WebApi from '@/views/loyalty/shared/modules/web_api'

// Кэш мест vending (place_id Charon == id места vending). Загружается один раз.
let promise = null
let byId = {}

// -> [{value, text}]
export function loadPlaces () {
  if (!promise) {
    promise = new WebApi().post('/api/place/list', { id: null, page: 1, limit: -1 })
      .then(res => {
        const list = (res && !res.error && Array.isArray(res.data)) ? res.data : []
        byId = {}
        for (const p of list) byId[String(p.id)] = p.name
        return list.map(p => ({ value: p.id, text: p.name }))
      })
      .catch(() => [])
  }
  return promise
}

// Название места по id (после loadPlaces); неизвестный id — как строка.
export function placeName (id) {
  return byId[String(id)] || String(id)
}
